
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxNetworkDiscovery(
    $timeout, $filter, toastr, $http, UnknownNetworkListPaging, SitesListPaging, SitesProviderService
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/setup/networkDiscovery/networkDiscovery.template.html',
      link: function(scope) {

        scope.requiredData = {
          networkName: null,
          selectedGateway: null,
          selectedSite: null
        };

        (function() {
          getUnknownNetworkStatus();
        })();



        function getUnknownNetworkStatus () {
          var url = scope.tenant.info._links['px:unknownNetworksStatus'].href;
          $http.get(url).then(function(response) {
            checkUnknownNetworkStatus(response.data);
          }).catch(function(error){
            console.log(error);
          });
        }


        function checkUnknownNetworkStatus (buildStatus) {
          if (buildStatus.rebuildStarted) {
            var buildStart = new Date(buildStatus.rebuildStarted).getTime();
            var currentTime = new Date().getTime();
            var difference = currentTime - buildStart;
            if (difference > 7200000) {
              buildUnknownNetworks(buildStatus);
            }
          }

          if (!buildStatus.rebuildStarted  ) {
            buildUnknownNetworks(buildStatus);
          }

          if (buildStatus.buildTime && !buildStatus.rebuildStarted) {

          }
        }

        function buildUnknownNetworks (buildStatus) {
          var url = buildStatus._links['px:rebuild'].href;

          $http.get(url).then(function(response){}).catch(function(error){
            console.log(error);
          });
        }

        scope.selectGatewayPaginated = function () {
          scope.unknownNetworkListPaging = new UnknownNetworkListPaging();
          scope.sitesListPaging = null;
        }

        scope.selectSitePaginated = function () {
          scope.sitesListPaging = new SitesListPaging();
          scope.sitesListPaging.pagingCriteria.page = 0;
          scope.sitesListPaging.pagingCriteria.pageSize = 20;
          scope.sitesListPaging.pagingCriteria.type = 'SINGLE';
          scope.unknownNetworkListPaging = null;
        }

        scope.selectGateway = function (network) {
          if (network) {
              scope.selectedGateway = network;
              $timeout(() => { scope.requiredData.selectedGateway = scope.selectedGateway }, 1000)
            } else {
              scope.requiredData.selectedGateway = scope.selectedGateway = null;
              scope.requiredData.selectedSite = scope.selectedSite = null;
            }
            scope.validateRequiredData();
          scope.unknownNetworkListPaging = null;
        }

        scope.selectSite = function (site) {
          if (site) {
            SitesProviderService.getSite(site.links.self.href).then(function(response) {
              scope.requiredData.selectedSite = scope.selectedSite = response;
              scope.validateRequiredData();
            }).catch(function(error){
              scope.validateRequiredData();
              console.log(error);
            });
          } else {
            scope.requiredData.selectedSite = scope.selectedSite = null;
            scope.validateRequiredData();
          }
          scope.sitesListPaging = null;
        }

        scope.validateRequiredData = function () {
          if (scope.requiredData.selectedGateway && scope.requiredData.selectedSite && scope.requiredData.networkName.length > 0) {
            scope.discoverIsValid = true;
          } else {
            scope.discoverIsValid = false;
          }
        }

        scope.save = function (event, context, menuOption, mappedNetworks) {
          scope.suppressSaveButton = true;

          $timeout(function  () {
            if (event, context, menuOption) {
              scope.selectedContextMenuItem  =  menuOption;
              scope.contextPosition =  { left: event.clientX, top: event.clientY };
              scope.context = context;
              scope.context.requiredData = scope.requiredData;
            }
          }, 50)
        }



        scope.closeAllMenues = function () {
          scope.suppressSaveButton = false;
          scope.selectedContextMenuItem  =  null;
          scope.contextPosition = null;
          scope.context = null;
        }


      }
    };
  }

  pxNetworkDiscovery.$inject = [
    '$timeout', '$filter', 'toastr', '$http', 'UnknownNetworkListPaging', 'SitesListPaging', 'SitesProviderService'
  ];

  angular
    .module('printix-admin')
    .directive('pxNetworkDiscovery', pxNetworkDiscovery);

})();
